<template>
  <a-card :bordered="false">
    <search-page-view
      :col="3"
      ref="pageList"
      :itemNames="['search_nickName','search_mobile']"
      :columns="columns"
      :queryParams="queryParams"
      row-key="id"
      :leftSpace="30"
      :requestPromise="loadPromise"
    >
      <a-form-item slot="search_nickName" label="昵称" v-bind="searchItemLayout">
        <a-input v-model="queryParams.nickName" placeholder="请输入"/>
      </a-form-item>
      <a-form-item slot="search_mobile" label="手机号" v-bind="searchItemLayout">
        <a-input v-model="queryParams.mobile" placeholder="请输入"/>
      </a-form-item>
      <span slot="suggestContent" slot-scope="rowItem">
        <ellipsis :length="30" tooltip>{{ rowItem.text }}</ellipsis>
      </span>
      <span slot="indexSlots" slot-scope="rowItem">{{ rowItem.index + 1 }}</span>
      <span slot="action" slot-scope="rowItem">
        <a @click="showModal(rowItem.record.id)">查看</a>
      </span>
    </search-page-view>
    <a-modal
      title="反馈详情"
      :width="666"
      v-model="visible"
      :footer="null"
      @cancel="visible = false"
    >
      <a-form-model
        :label-col="labelCol"
        :wrapper-col="wrapperCol">
        <a-form-model-item label="反馈内容" prop="merchantName">
          {{ detailList.suggestContent }}
        </a-form-model-item>
        <div v-if="detailList.imgList&&detailList.imgList.length>0">
          <a-form-model-item label="图片凭证" prop="merchantName">
            <div class="img-box">
              <img
                @click="showBigImage(item)"
                v-for='(item,index) in detailList.imgList'
                :src="item+'?x-oss-process=image/resize,limit_0,m_fill,h_100,w_100'"
              >
            </div>
          </a-form-model-item>
        </div>
        <a-form-model-item label="提交时间">
          {{ detailList.gmtCreate }}
        </a-form-model-item>
        <a-form-model-item :wrapper-col="{offset:20}">
          <a-button @click="visible = false">关闭</a-button>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <div class="big-img" v-if="showImg" @click="showImg = false">
      <img :src="bigImg" alt="">
    </div>
  </a-card>
</template>

<script>
import searchForm from '@/utils/mixins/searchFormMixins'

export default {
  name: 'FeedbackList',
  mixins: [searchForm],
  data() {
    return {
      columns: [
        {
          title: '序号',
          dataIndex: 'index',
          scopedSlots: { customRender: 'indexSlots' }
        },
        {
          title: '昵称',
          dataIndex: 'nickName'
        },
        {
          title: '手机号',
          dataIndex: 'mobile'
        },
        {
          title: '反馈内容',
          dataIndex: 'suggestContent',
          scopedSlots: { customRender: 'suggestContent' }
        },
        {
          title: '提交时间',
          dataIndex: 'gmtCreate'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '90px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ],
      visible: false,
      loadPromise: params => this.getModularListPromise(params),
      queryParams: {},
      labelCol: { span: 6 },
      wrapperCol: { span: 18 },
      merchantId: this.$store.getters.userInfo.merchantId,
      platformId: this.getPlatformConfig().platformId,
      detailList: {},
      bigImg: '',
      showImg: false
    }
  },
  mounted() {
    this.$store.commit('SET_MENU_HEAD_CONFIG', [
      { name: 'FeedbackList', title: '反馈列表' }
    ])
  },
  methods: {
    showBigImage(item) {
      this.bigImg = item
      this.showImg = true
    },
    getModularListPromise(params) {
      params.merchantId = this.merchantId
      params.platformId = this.platformId
      return this.getHttpServices().getServerApiService().post('suggest/feedback/list', params)
    },
    showModal(id) {
      this.visible = true
      this.getDetails(id)
    },
    getDetails(id) {
      let url = 'suggest/feedback/' + id
      this.getHttpServices().getServerApiService().post(url)
        .then(res => {
          if (res.suggestUrl) {
            res.imgList = res.suggestUrl.split(',')
          }
          this.detailList = res
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    }
  }
}
</script>

<style lang="less" scoped>
.button-box {
  margin-bottom: 20px;
}

.selected-image {
  width: 100px;
  height: 100px;
}

.img-box {
  display: flex;
  flex-wrap: wrap;

  img {
    width: 100px;
    height: 100px;
    margin-right: 20px;
    margin-bottom: 20px;
  }
}

.big-img {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 1001;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 800px;
  }
}

.content-text {
  //white-space: nowrap;
  //text-overflow:ellipsis;
  //overflow: hidden;
}
</style>